import { createTheme, lighten } from "@mui/material";
import { ReactComponent as ArrowDownwardIcon } from "./assets/icons/arrow-downward.svg";

export const muiTheme = (brandColor: string) =>
  createTheme({
    custom: {
      brandColor,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: "capitalize",
            fontSize: 13,
            fontWeight: 500,
            textWrap: "nowrap",
            color: "#333333",
            boxShadow: "none",
          },
          contained: {
            backgroundColor: brandColor,
            color: "#fff",
            "&:hover": {
              boxShadow: "none",
              backgroundColor: lighten(brandColor, 0.2),
            },
            "&.Mui-disabled": {
              backgroundColor: lighten(brandColor, 0.4),
              color: "#fff",
            },
          },
          outlined: {
            borderColor: "#CCD2DE",
            "&:hover": {
              borderColor: "#a2a4a8",
            },
          },
          text: {
            fontSize: 11,
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          IconComponent: ArrowDownwardIcon,
        },
        styleOverrides: {
          icon: {
            right: 10,
            top: "25%",
          },
        },
      },
    },
  });
